import { IQualifiedGuildRecruitmentTag } from '../sharedTypes';

export const QUALIFIED_GUILD_RECRUITMENT_TAGS: IQualifiedGuildRecruitmentTag[] = [];

